import { IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';


export default function GbSearchIcon(props) {
    const handleChange = props.handleChange
    const val = props.val
    return (
        <IconButton
            size="small"
            onClick={() => handleChange(val)}
            sx={{ "&:hover": { color: "sdeBlue.light", color: "black" } }}
        ><SearchIcon />
        </IconButton>
    )
}